<div class="modal-header">
  <h3 class="modal-title">Terms & Conditions</h3>
</div>
<div class="modal-body clearfix">
  <div class="container-fluid">
    <div class="col-lg-12">
      <p>
        Please note that your contribution on this Site is entirely voluntary,
        non-confidential and gratuitous. Your contribution is visible to the
        other users and the administrator.
      </p>
      <p>
        In this ideation session, we reach out to you to help us come up with
        innovative solutions within the goal set out in the session description.
      </p>
      <!--
      <p>
        You agree that the data generated on this site can be used for analysis for scientific analysis, a university course project and for showcase purposes of the software. It is guaranteed that any personal data will not be handed on to any third parties. In the case of the publication in a scientific journal or paper it will not be possible to deduce from the data who participated in the study. Your personal data underlies the data privacy act. If you do not want us to use that data, please write to veronika.gamper@wedavinci.com.
      </p>
      -->
      <p>
        Your personal data underlies the data privacy act. You can find our data
        protection policy
        <a
          href="https://www.wedavinci.com/data-protection-policy"
          target="_blank">
          here
        </a>
        .
      </p>
      <p>
        The project partner on the ideation session and Veronika Gamper may
        approach you via email or this site to further pursue any contribution
        or invite you to contribute to challenges. You can opt out to be
        contacted by writing to veronika.gamper&#64;wedavinci.com.
      </p>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-warning" type="button" (click)="dismiss()">
    Cancel
  </button>
</div>
